import { Component } from '@angular/core';
import { Inventura } from '@app/shared/models/inventura';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-edit-inventura-item-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditInventuraItemActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => {
        const locked =
          ((item as Inventura)[
            'earhiv~inventura~status_inventure'
          ] as string) || 'U_TIJEKU';
        let disabled = false;
        if (locked === 'ZAVRSENA') {
          disabled = true;
        }
        return disabled;
      })
    );
  }
}
